export const styles = {
  main: {
    backgroundColor: "transparent",
    "& .MuiPopover-paper": {
      backgroundColor: "transparent",
      borderRadius: 1.25,
    },
    "& .EmojiPickerReact": {
      "--epr-emoji-size": "18px",
      "--epr-picker-border-radius": "5px",
      "--epr-category-navigation-button-size": "20px",
      // "& .epr-preview": {
      //     display: "none",
      // }
    },
  },
}
